// extracted by mini-css-extract-plugin
module.exports = {"layout":"styles_layout__Zkjid","main":"styles_main__AIw_d","side":"styles_side__iviI4","sticky":"styles_sticky__5pJ6x"};